import { useState, useEffect } from "react";
import { Button, Form, Modal, Accordion } from "react-bootstrap";
import styles from "../styles/AgendamentoRevisao.module.scss";
import Select from "react-select";
import FormInput from "../components/AgendamentoRevisao/FormInput";
import { toast } from "react-toastify";
import { api } from "../services/api";
import { useMisc } from '../contexts/MiscContext';
import Tabela from "../components/Misc/Tabela/Tabela";

const AgendamentoRevisao = () => {
  const { showLoading, setShowLoading } = useMisc();
  const [acaoSelecionada, setAcaoSelecionada] = useState({ label: "100%", value: "cemPorcento" });
  const [filterDataRetorno, setFilterDataRetorno] = useState({ ordem_servico: '' });
  const [filterData100, setFilterData100] = useState({ nf_entrada: '', material: '', cor_material: '', pedido: '', limite_meses: false });
  const [mainDataCem, setMainDataCem] = useState([]);
  const [mainDataRetorno, setMainDataRetorno] = useState([]);
  const [activeObjectCem, setActiveObjectCem] = useState({});
  const [activeObjectRetorno, setActiveObjectRetorno] = useState({});
  const [showModalCemPorcento, setShowModalCemPorcento] = useState(false);
  const [showModalRetorno, setShowModalRetorno] = useState(false);

  const selecionarAcao = [
    { label: "Buscar 100%", value: "cemPorcento" },
    { label: "Buscar Retorno", value: "retorno" },
  ];

  const filterDataHandler = (value, field) => {
    setFilterData100({ ...filterData100, [field]: value });
    if (field === 'ordem_servico') setFilterDataRetorno({ ...filterDataRetorno, ordem_servico: value });
  };

  const handleOpenModalsCem = row => acaoSelecionada.value === 'cemPorcento' && (setShowModalCemPorcento(true), setActiveObjectCem({
    Fornecedor: row.FORNECEDOR, NF: row.NF_ENTRADA, Pedido: row.PEDIDO, Material: row.MATERIAL, Cor: row.COR_MATERIAL, QuantidadeEntrada: row.QTDE_ENTRADA, DESC_MATERIAL: row.DESC_MATERIAL, DESC_COR_MATERIAL: row.DESC_COR_MATERIAL, QTDE_ESTOQUE: row.QTDE_ENTRADA, TIPO_COMPRA: row.TIPO_COMPRA, DATAREVISAO: row.DATAREVISAO, AgendadoRevisao: row.AgendadoRevisao, AgendadoLaboratorio: row.AgendadoLaboratorio, _originalAgendadoRevisao: row.AgendadoRevisao, _originalAgendadoLaboratorio: row.AgendadoLaboratorio
  }));
  const handelOpenModalsRetorno = row => acaoSelecionada.value === 'retorno' && (setShowModalRetorno(true), setActiveObjectRetorno({
    OrdemProducao: row.ORDEM_PRODUCAO, OrdemServico: row.ORDEM_SERVICO, FASE_PRODUCAO: row.FASE_PRODUCAO, ORIGEM: row.ORIGEM, MARCA: row.MARCA, PRODUTO: row.PRODUTO, DESC_PRODUTO: row.DESC_PRODUTO, QTDE_PECAS_OP: row.QTDE_PECAS_OP, TIPO_ORDEM_PRODUCAO: row.TIPO_ORDEM_PRODUCAO, COLECAO: row.COLECAO, AgendadoRevisao: row.AgendadoRevisao, AgendadoLaboratorio: row.AgendadoLaboratorio, _originalAgendadoRevisao: row.AgendadoRevisao, _originalAgendadoLaboratorio: row.AgendadoLaboratorio
  }));
  const handleCloseModals = () => (setShowModalRetorno(false), setShowModalCemPorcento(false), setActiveObjectCem({}));

  const handleProcessarRetorno = async () => {
    try {
      setShowLoading(true);
      if (!activeObjectRetorno._originalAgendadoRevisao && !activeObjectRetorno._originalAgendadoLaboratorio) {
        const send = {
          acao: 0,
          revisaoLaboratorio: {
            ...activeObjectRetorno,
            AgendadoRevisao: activeObjectRetorno.AgendadoRevisao ? 1 : 0,
            AgendadoLaboratorio: activeObjectRetorno.AgendadoLaboratorio ? 1 : 0
          }
        };
        const res = await api.post('/agendamento-revisao/agendamentoRevisaoProcessarRetorno', { send });
        if (res.status === 200) {
          handleCloseModals();
          fetchGridRetorno();
          toast.success('Os dados foram salvos com sucesso!');
        }
      } else {
        let novosDados = {};
        if (!activeObjectRetorno._originalAgendadoRevisao && activeObjectRetorno.AgendadoRevisao) {
          novosDados = { AgendadoRevisao: 1 };
        } else if (!activeObjectRetorno._originalAgendadoLaboratorio && activeObjectRetorno.AgendadoLaboratorio) {
          novosDados = { AgendadoLaboratorio: 1 };
        }
        if (Object.keys(novosDados).length > 0) {
          let tipo = '';
          if (novosDados.AgendadoRevisao) tipo = 'revisao';
          else if (novosDados.AgendadoLaboratorio) tipo = 'laboratorio';
          await api.post('/agendamento-revisao/agendamento-retorno-update', {
            tipo,
            chave: {
              OrdemProducao: activeObjectRetorno.OrdemProducao,
              OrdemServico: activeObjectRetorno.OrdemServico,
              Produto: activeObjectRetorno.Produto,
              Colecao: activeObjectRetorno.Colecao
            },
            novosDados
          });
          handleCloseModals();
          fetchGridRetorno();
          toast.success('Os dados foram atualizados com sucesso!');
        }
      }
    } catch (e) {
      toast.error('Erro ao processar!');
    } finally {
      setShowLoading(false);
    }
  };

  const handleProcessar100 = async () => {
    try {
      setShowLoading(true);
      if (!activeObjectCem._originalAgendadoRevisao && !activeObjectCem._originalAgendadoLaboratorio) {
        const send = {
          acao: 0,
          revisaoLaboratorio: {
            ...activeObjectCem,
            AgendadoRevisao: activeObjectCem.AgendadoRevisao ? 1 : 0,
            AgendadoLaboratorio: activeObjectCem.AgendadoLaboratorio ? 1 : 0
          }
        };
        const res = await api.post('/agendamento-revisao/agendamentoRevisaoProcessar100', { send });
        if (res.status === 200) {
          handleCloseModals();
          toast.success('Os dados foram salvos com sucesso!');
          fetchGrid100PorCento();
        }
      } else {
        let tipo = '';
        let novosDados = {};
        if (!activeObjectCem._originalAgendadoRevisao && activeObjectCem.AgendadoRevisao) {
          tipo = 'revisao';
          novosDados = { AgendadoRevisao: 1 };
        } else if (!activeObjectCem._originalAgendadoLaboratorio && activeObjectCem.AgendadoLaboratorio) {
          tipo = 'laboratorio';
          novosDados = { AgendadoLaboratorio: 1 };
        }
        if (tipo) {
          await api.post('/agendamento-revisao/agendamento-cem-update', {
            tipo,
            chave: {
              NFEntrada: activeObjectCem.NF,
              Pedido: activeObjectCem.Pedido,
              Material: activeObjectCem.Material,
              Cor: activeObjectCem.Cor
            },
            novosDados
          });
          handleCloseModals();
          toast.success('Os dados foram atualizados com sucesso!');
          fetchGrid100PorCento();
        }
      }
    } catch (e) {
      toast.error('Erro ao processar!');
    } finally {
      setShowLoading(false);
      handleCloseModals();
    }
  };

  const fetchGrid100PorCento = async () => {
    try {
      setShowLoading(true);
      const params = { ...filterData100, limite_meses: filterData100.limite_meses === true ? true : null };
      const res = await api.get(`/agendamento-revisao/get-100-main-grid`, { params });
      setMainDataCem([...res.data]);
    } catch (e) {
      toast.error('Erro ao realizar a busca!');
    } finally {
      setShowLoading(false);
    }
  };

  const fetchGridRetorno = async () => {
    try {
      setShowLoading(true);
      const params = {};
      if (filterDataRetorno.ordem_servico && filterDataRetorno.ordem_servico.trim() !== "") params.ordem_servico = filterDataRetorno.ordem_servico.trim();
      const res = await api.get(`agendamento-revisao/get-retorno-main-grid`, { params });
      setMainDataRetorno([...res.data]);
    } catch (e) {
      toast.error('Erro ao realizar a busca!');
    } finally {
      setShowLoading(false);
    }
  };

  const agendamentoColumns100 = [
    {
      cell: row => (
        <Button variant={'primary'} onClick={() => handleOpenModalsCem(row)}>
          Agendar
        </Button>
      )
    },
    {name: 'FORNECEDOR', selector: row => row.FORNECEDOR},
    {name: 'NF ENTRADA', selector: row => row.NF_ENTRADA ?? ''},
    {name: 'PEDIDO', selector: row => row.PEDIDO},
    {name: 'MATERIAL', selector: row => row.MATERIAL},
    {name: 'DESCRIÇÃO MATERIAL', selector: row => row.DESC_MATERIAL},
    {name: 'COR MATERIAL', selector: row => row.COR_MATERIAL},
    {name: 'DESCRIÇÃO COR MATERIAL', selector: row => row.DESC_COR_MATERIAL},
    {name: 'QTDE ENTRADA', selector: row => row.QTDE_ENTRADA ?? 0},
    {name: 'QTDE ESTOQUE', selector: row => row.QTDE_ESTOQUE},
    {name: 'TIPO COMPRA', selector: row => row.TIPO_COMPRA},
    {name: 'DATA REVISÃO', selector: row => row.DATAREVISAO},
    {name: 'ENTRADA REVISÃO POR', selector: row => row.ENTRADA_REVISADO_POR}
  ];

  const agendamentoColumnsRetorno = [
    {
      cell: row => (
        <Button variant={'primary'} onClick={() => handelOpenModalsRetorno(row)}>
          Agendar
        </Button>
      )
    },
    {name: 'ORDEM PRODUÇÃO', selector: row => row.ORDEM_PRODUCAO},
    {name: 'ORDEM SERVIÇO', selector: row => row.ORDEM_SERVICO},
    {name: 'FASE PRODUÇÃO', selector: row => row.FASE_PRODUCAO},
    {name: 'ORIGEM', selector: row => row.ORIGEM},
    {name: 'MARCA', selector: row => row.MARCA},
    {name: 'PRODUTO', selector: row => row.PRODUTO},
    {name: 'DESCRIÇÃO PRODUTO', selector: row => row.DESC_PRODUTO},
    {name: 'QTDE PEÇAS OP', selector: row => row.QTDE_PECAS_OP},
    {name: 'TIPO ORDEM PRODUÇÃO', selector: row => row.TIPO_ORDEM_PRODUCAO},
    {name: 'COLEÇÃO', selector: row => row.COLECAO}
  ];

  function splitObjectIntoColumns(fields, obj, numCols = 3) {
    const entries = fields.map(f => [f.label, obj[f.key]]);
    const perCol = Math.ceil(entries.length / numCols);
    return Array.from({ length: numCols }, (_, i) => entries.slice(i * perCol, (i + 1) * perCol));
  }

  function formatDateISOToBR(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hour = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${year}/${month}/${day} - ${hour}:${min}`;
  }

  useEffect(() => {
    if (acaoSelecionada.value === 'cemPorcento') fetchGrid100PorCento();
    else fetchGridRetorno();
  }, [acaoSelecionada]);

  useEffect(() => {
    if (acaoSelecionada.value === 'cemPorcento') fetchGrid100PorCento();
  }, [filterData100.limite_meses, acaoSelecionada.value]);

  return (
    <div>
      <h3 style={{ margin: "20px" }}>
        {acaoSelecionada.value === 'retorno' ? 'Agendamento Revisão Retorno' : 'Agendamento Revisão 100%'}
      </h3>
      <article className={styles.headerWrapper}>
        <article className={styles.actionWrapper}>
          <div className="ms-2">
            <Form className={styles.form}>
              <Form.Group className={styles.formGroup}>
                <Form.Label className={styles.formLabel}>Ação de busca:</Form.Label>
                <Select
                  closeMenuOnSelect={true}
                  backspaceRemovesValue={true}
                  placeholder={"Selecionar"}
                  value={acaoSelecionada}
                  options={selecionarAcao}
                  onChange={setAcaoSelecionada}
                />
              </Form.Group>
            </Form>
          </div>
        </article>
        <article className={styles.formWrapper}>
          <Form className={styles.form}>
            {
              acaoSelecionada?.value === "cemPorcento"
                ? <div className="d-flex">
                  <FormInput value={filterData100.nf_entrada} onChange={e => filterDataHandler(e.target.value, 'nf_entrada')} label="Nota Fiscal*" placeholder="Nota Fiscal" type="text" />
                  <FormInput value={filterData100.material} onChange={e => filterDataHandler(e.target.value, 'material')} label="Material*" placeholder="Material" type="text" />
                  <FormInput value={filterData100.cor_material} onChange={e => filterDataHandler(e.target.value, 'cor_material')} label="Cor Material*" placeholder="Cor Material" type="text" />
                  <FormInput value={filterData100.pedido} onChange={e => filterDataHandler(e.target.value, 'pedido')} label="Pedido*" placeholder="Pedido" type="text" />
                </div>
                : <div className="d-flex">
                  <FormInput value={filterData100.ordem_servico} onChange={e => filterDataHandler(e.target.value, 'ordem_servico')} label="Ordem Serviço*" placeholder="Ordem Serviço" type="text" />
                </div>
            }
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 16 }}>
              <Button className={styles.formGroup} variant="primary" type="button" onClick={acaoSelecionada.value === 'cemPorcento' ? fetchGrid100PorCento : fetchGridRetorno} disabled={showLoading}>
                {showLoading ? "Buscando..." : "Buscar"}
              </Button>
              {acaoSelecionada.value === 'cemPorcento' && (
                <Form.Check
                  type={'switch'}
                  id="limiteMeses-switch"
                  label="Limite 18 Meses"
                  style={{ fontWeight: '500', fontSize: '18px', marginLeft: 8 }}
                  checked={filterData100.limite_meses === true}
                  onChange={() => setFilterData100({ ...filterData100, limite_meses: !filterData100.limite_meses })}
                />
              )}
            </div>
          </Form>
        </article>
      </article>
      <section style={{ margin: '0px 20px 20px' }}>
        <Tabela
          columns={acaoSelecionada.value === 'cemPorcento' ? agendamentoColumns100 : agendamentoColumnsRetorno}
          data={acaoSelecionada.value === 'cemPorcento' ? mainDataCem : mainDataRetorno}
          pending={false}
          pagination={true}
          paginationPerPage={20}
          highlightOnHover={true}
        />
      </section>
      <Modal show={showModalCemPorcento} onHide={handleCloseModals} backdrop="static" keyboard={false} size="lg" centered>
        <Modal.Header>
          <Modal.Title>Agendar - 100%</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <article>
            <Accordion defaultActiveKey={["0"]} alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Dados do Pedido</Accordion.Header>
                <Accordion.Body className={styles.pedidoModalBody}>
                  <div className={styles.pedidoModalColumns}>
                    {splitObjectIntoColumns([
                      { key: 'Fornecedor', label: 'Fornecedor' },
                      { key: 'NF', label: 'NF Entrada' },
                      { key: 'Pedido', label: 'Pedido' },
                      { key: 'Material', label: 'Material' },
                      { key: 'Cor', label: 'Cor' },
                      { key: 'DESC_MATERIAL', label: 'Descrição Material' },
                      { key: 'DESC_COR_MATERIAL', label: 'Descrição Cor Material' },
                      { key: 'QuantidadeEntrada', label: 'Quantidade Entrada' },
                      { key: 'QTDE_ESTOQUE', label: 'Quantidade Estoque' },
                      { key: 'TIPO_COMPRA', label: 'Tipo Compra' },
                      { key: 'DATAREVISAO', label: 'Data Revisão' }
                    ], activeObjectCem, 3).map((col, idx) => (
                      <div key={idx} className={styles.pedidoModalCol}>
                        {col.map(([label, value]) => (
                          <div key={label} className={styles.pedidoModalField}>
                            <b className={styles.pedidoModalLabel}>{label}:</b>
                            <span className={styles.pedidoModalValue} title={label === 'Data Revisão' ? formatDateISOToBR(value) : value}>
                              {label === 'Data Revisão' ? formatDateISOToBR(value) : value}
                            </span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </article>
          <article>
            <div className={styles.marginTop}>
              <Form className="m-2">
                <Form.Group className={styles.formControl} style={{ marginBottom: "20px" }}>
                  <Form.Label className={styles.formLabel}>Selecione a análise:</Form.Label>
                  <Form.Check
                    type={"checkbox"}
                    label={"Revisão"}
                    name='agendado'
                    value='revisao'
                    checked={!!activeObjectCem.AgendadoRevisao}
                    disabled={!!activeObjectCem._originalAgendadoRevisao}
                    onChange={e => setActiveObjectCem({ ...activeObjectCem, AgendadoRevisao: e.target.checked })}
                  />
                  <Form.Check
                    type={"checkbox"}
                    label={"Laboratório"}
                    name='agendado'
                    value='laboratorio'
                    checked={!!activeObjectCem.AgendadoLaboratorio}
                    disabled={!!activeObjectCem._originalAgendadoLaboratorio}
                    onChange={e => setActiveObjectCem({ ...activeObjectCem, AgendadoLaboratorio: e.target.checked })}
                  />
                </Form.Group>
              </Form>
            </div>
          </article>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button variant="outline-danger" onClick={handleCloseModals} className={styles.modalBtn}>Cancelar</Button>
          <Button variant="primary" className={styles.modalBtn} onClick={handleProcessar100} disabled={showLoading}>Processar 100%</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalRetorno} onHide={handleCloseModals} backdrop="static" keyboard={false} size="lg" centered>
        <Modal.Header>
          <Modal.Title>Agendar - Retorno</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <article>
            <Accordion defaultActiveKey={["0"]} alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Dados do Pedido</Accordion.Header>
                <Accordion.Body className={styles.pedidoModalBody}>
                  <div className={styles.pedidoModalColumns}>
                    {splitObjectIntoColumns([
                      { key: 'OrdemProducao', label: 'Ordem Produção' },
                      { key: 'OrdemServico', label: 'Ordem Serviço' },
                      { key: 'FASE_PRODUCAO', label: 'Fase Produção' },
                      { key: 'ORIGEM', label: 'Origem' },
                      { key: 'MARCA', label: 'Marca' },
                      { key: 'PRODUTO', label: 'Produto' },
                      { key: 'DESC_PRODUTO', label: 'Descrição Produto' },
                      { key: 'QTDE_PECAS_OP', label: 'Qtde Peças OP' },
                      { key: 'TIPO_ORDEM_PRODUCAO', label: 'Tipo Ordem Produção' },
                      { key: 'COLECAO', label: 'Coleção' }
                    ], activeObjectRetorno, 3).map((col, idx) => (
                      <div key={idx} className={styles.pedidoModalCol}>
                        {col.map(([label, value]) => (
                          <div key={label} className={styles.pedidoModalField}>
                            <b className={styles.pedidoModalLabel}>{label}:</b>
                            <span className={styles.pedidoModalValue} title={value}>{value}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </article>
          <article>
            <div className={styles.marginTop}>
              <Form className="m-2">
                <Form.Group className={styles.formControl} style={{ marginBottom: "20px" }}>
                  <Form.Label className={styles.formLabel}>Selecione a análise:</Form.Label>
                  <Form.Check
                    type={"checkbox"}
                    label={"Revisão"}
                    name='agendado'
                    value='revisao'
                    checked={!!activeObjectRetorno.AgendadoRevisao}
                    disabled={!!activeObjectRetorno._originalAgendadoRevisao}
                    onChange={e => setActiveObjectRetorno({ ...activeObjectRetorno, AgendadoRevisao: e.target.checked })}
                  />
                  <Form.Check
                    type={"checkbox"}
                    label={"Laboratório"}
                    name='agendado'
                    value='laboratorio'
                    checked={!!activeObjectRetorno.AgendadoLaboratorio}
                    disabled={!!activeObjectRetorno._originalAgendadoLaboratorio}
                    onChange={e => setActiveObjectRetorno({ ...activeObjectRetorno, AgendadoLaboratorio: e.target.checked })}
                  />
                </Form.Group>
              </Form>
            </div>
          </article>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button variant="outline-danger" onClick={handleCloseModals} className={styles.modalBtn}>Cancelar</Button>
          <Button variant="primary" className={styles.modalBtn} onClick={handleProcessarRetorno} disabled={showLoading}>Processar Retorno</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AgendamentoRevisao;
